module.exports = __webpack_public_path__ + "static/media/45mm.89da53cb.jpg";